import Landing from "views/landing";
import "../assets/styles/main.scss";

const App = () => {
  return (
    <Landing />
  );
};

export default App;
